import { motion } from "framer-motion";
import Reveal, { EASE } from "./Reveal";

const WORDS = ["BUILD.", "HOLD.", "GROW."];

export default function Convergence() {
  return (
    <section
      data-testid="convergence"
      className="px-6 py-32 text-center sm:py-44"
    >
      <Reveal>
        <p className="f-mono text-[11px] tracking-[0.4em] text-[#B8860B]">
          REAL ESTATE &times; EQUITIES &times; PRIVATE EQUITY
        </p>
      </Reveal>
      <Reveal delay={0.15}>
        <h2 className="f-display mt-8 text-3xl font-light tracking-tight text-slate-900 sm:text-5xl">
          Different assets. <span className="italic text-[#B8860B]">One philosophy.</span>
        </h2>
      </Reveal>
      <div className="mt-16">
        {WORDS.map((w, i) => (
          <motion.div
            key={w}
            className="overflow-hidden"
            initial="hidden"
            whileInView="show"
            viewport={{ once: true, margin: "-12% 0px" }}
          >
            <motion.p
              variants={{ hidden: { y: "112%" }, show: { y: "0%" } }}
              transition={{ duration: 1.05, delay: i * 0.14, ease: EASE }}
              className={`f-display text-[16vw] font-medium leading-[0.92] tracking-tight sm:text-[9rem] ${
                i === 1 ? "gold-outline" : "text-slate-900"
              }`}
            >
              {w}
            </motion.p>
          </motion.div>
        ))}
      </div>
    </section>
  );
}
